/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M20 9L20.6431 9.25724C21.7646 9.70586 22.5 10.7921 22.5 12C22.5 13.208 21.7646 14.2942 20.643 14.7428L20 15M7 10L7 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11.4C2 9.15979 2 8.03968 2.43597 7.18404C2.81947 6.43139 3.43139 5.81947 4.18404 5.43597C5.03968 5 6.15979 5 8.4 5H13.6C15.8402 5 16.9603 5 17.816 5.43597C18.5686 5.81947 19.1805 6.43139 19.564 7.18404C20 8.03968 20 9.15979 20 11.4V12.6C20 14.8402 20 15.9603 19.564 16.816C19.1805 17.5686 18.5686 18.1805 17.816 18.564C16.9603 19 15.8402 19 13.6 19H8.4C6.15979 19 5.03968 19 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.816C2 15.9603 2 14.8402 2 12.6V11.4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 11.4C2 9.15979 2 8.03969 2.43597 7.18404C2.81947 6.43139 3.43139 5.81947 4.18404 5.43597C5.03969 5 6.15979 5 8.4 5H13.6C15.8402 5 16.9603 5 17.816 5.43597C18.5686 5.81947 19.1805 6.43139 19.564 7.18404C20 8.03969 20 9.15979 20 11.4V12.6C20 14.8402 20 15.9603 19.564 16.816C19.1805 17.5686 18.5686 18.1805 17.816 18.564C16.9603 19 15.8402 19 13.6 19H8.4C6.15979 19 5.03969 19 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.816C2 15.9603 2 14.8402 2 12.6V11.4Z"
				fill="currentColor"
			/>
			<path
				d="M7 10V14M20 9L20.6431 9.25724C21.7646 9.70586 22.5 10.7921 22.5 12C22.5 13.208 21.7646 14.2942 20.643 14.7428L20 15M8.4 19H13.6C15.8402 19 16.9603 19 17.816 18.564C18.5686 18.1805 19.1805 17.5686 19.564 16.816C20 15.9603 20 14.8402 20 12.6V11.4C20 9.15979 20 8.03968 19.564 7.18404C19.1805 6.43139 18.5686 5.81947 17.816 5.43597C16.9603 5 15.8402 5 13.6 5H8.4C6.15979 5 5.03968 5 4.18404 5.43597C3.43139 5.81947 2.81947 6.43139 2.43597 7.18404C2 8.03968 2 9.15979 2 11.4V12.6C2 14.8402 2 15.9603 2.43597 16.816C2.81947 17.5686 3.43139 18.1805 4.18404 18.564C5.03968 19 6.15979 19 8.4 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.65024 19.75C5.41003 19.75 4.28993 19.75 3.43428 19.314C2.68163 18.9305 2.06971 18.3186 1.68622 17.566C1.25024 16.7103 1.25024 15.5902 1.25024 13.35L1.25024 13.35L1.25024 10.65C1.25024 8.40979 1.25024 7.28969 1.68622 6.43404C2.06971 5.68139 2.68163 5.06947 3.43428 4.68598C4.28993 4.25 5.41003 4.25 7.65024 4.25L14.3502 4.25C16.5905 4.25 17.7106 4.25 18.5662 4.68598C19.3189 5.06947 19.9308 5.68139 20.3143 6.43404C20.6016 6.99792 20.6996 7.67666 20.733 8.71514L20.783 8.72944C22.2433 9.14666 23.25 10.4813 23.25 12C23.25 13.5187 22.2432 14.8534 20.783 15.2706L20.733 15.2849C20.6996 16.3234 20.6016 17.0021 20.3143 17.566C19.9308 18.3186 19.3189 18.9305 18.5662 19.314C17.7106 19.75 16.5905 19.75 14.3503 19.75L14.3502 19.75L7.65024 19.75ZM20.7502 10.65L20.7502 10.3258C21.3564 10.6521 21.75 11.2901 21.75 12C21.75 12.71 21.3564 13.348 20.7502 13.6743L20.7502 13.35L20.7502 10.65L20.7502 10.65ZM7.75 10C7.75 9.58579 7.41421 9.25 7 9.25C6.58579 9.25 6.25 9.58579 6.25 10L6.25 14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14L7.75 10Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 5H9.5H8.4C6.15979 5 5.03968 5 4.18404 5.43597C3.43139 5.81947 2.81947 6.43139 2.43597 7.18404C2 8.03968 2 9.15979 2 11.4V12.6C2 14.8402 2 15.9603 2.43597 16.816C2.81947 17.5686 3.43139 18.1805 4.18404 18.564C5.03968 19 6.15979 19 8.4 19H13.6C15.8402 19 16.9603 19 17.816 18.564C18.5686 18.1805 19.1805 17.5686 19.564 16.816C20 15.9603 20 14.8402 20 12.6V10.5C20 9.10444 20 8.40666 19.8278 7.83886C19.44 6.56046 18.4395 5.56004 17.1611 5.17224C16.5933 5 15.8956 5 14.5 5V5H14M7 10V14M20 9L20.6431 9.25724C21.7646 9.70586 22.5 10.7921 22.5 12C22.5 13.208 21.7646 14.2942 20.643 14.7428L20 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7.00001 10V14M20 9L20.6431 9.25723C21.7646 9.70586 22.5 10.7921 22.5 12C22.5 13.2079 21.7646 14.2942 20.643 14.7428L20 15M8.4 19H13.6C15.8402 19 16.9603 19 17.816 18.564C18.5686 18.1805 19.1805 17.5686 19.564 16.816C20 15.9603 20 14.8402 20 12.6V11.4C20 9.15979 20 8.03968 19.564 7.18404C19.1805 6.43139 18.5686 5.81947 17.816 5.43597C16.9603 5 15.8402 5 13.6 5H8.40001C6.1598 5 5.03969 5 4.18404 5.43597C3.4314 5.81947 2.81947 6.43139 2.43598 7.18404C2.00001 8.03968 2.00001 9.15979 2.00001 11.4V12.6C2.00001 14.8402 2.00001 15.9603 2.43598 16.816C2.81947 17.5686 3.4314 18.1805 4.18404 18.564C5.03969 19 6.1598 19 8.4 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.65024 19.75C5.41003 19.75 4.28993 19.75 3.43428 19.314C2.68163 18.9305 2.06971 18.3186 1.68622 17.566C1.25024 16.7103 1.25024 15.5902 1.25024 13.35L1.25024 10.65C1.25024 8.40979 1.25024 7.28969 1.68622 6.43404C2.06971 5.68139 2.68163 5.06947 3.43428 4.68597C4.28993 4.25 5.41003 4.25 7.65024 4.25L14.3502 4.25C16.5905 4.25 17.7106 4.25 18.5662 4.68597C19.3189 5.06947 19.9308 5.68139 20.3143 6.43404C20.7502 7.28969 20.7502 8.40979 20.7502 10.65V13.35C20.7502 15.5902 20.7502 16.7103 20.3143 17.566C19.9308 18.3186 19.3189 18.9305 18.5662 19.314C17.7106 19.75 16.5905 19.75 14.3502 19.75H7.65024Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.75 10C7.75 9.58579 7.41421 9.25 7 9.25C6.58579 9.25 6.25 9.58579 6.25 10L6.25 14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14L7.75 10ZM23 11.9419L23 12.25C23 13.4926 21.9926 14.5 20.75 14.5L20.75 9.69189C21.9926 9.69189 23 10.6993 23 11.9419Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
